import {Dropdown} from 'react-bootstrap';
import {Link, NavigateFunction, useNavigate} from 'react-router-dom';
import {useAuth} from '../../../context/AuthContext';
import Classes from '../NavBar.module.scss';
import CameraIcon from '../../../assets/icons/camera.svg';
import userIcon from '../../../assets/icons/logUser.svg';


const UserMenu = () => {
    const {storedUserData, logOut} = useAuth();
    const navigate: NavigateFunction = useNavigate();

    return (
        <Dropdown.Menu className={Classes.menuWrap}>
            <div className={`${Classes.userInfoWrap} d-flex align-items-center`}>
                <div className={`${Classes.mobileAvatar} me-2`}>
                    <img
                        src={storedUserData?.profilePic ? `${process.env.REACT_APP_MEDIA_SERVER}/${storedUserData?.profilePic}` : userIcon}
                        alt={storedUserData?.userName}
                        className={'img-fluid rounded-circle'}
                        width={64}
                        height={64}
                    />
                    <Dropdown.Item
                        as={Link}
                        to={'/dashboard/account-settings'}
                        className={`${Classes.profilePicUploadBtn} d-flex align-items-center justify-content-center`}
                    >
                        <img src={CameraIcon} alt="Upload Profile Thumbnail"/>
                    </Dropdown.Item>
                </div>
                <div className={Classes.nameUser}>
                    <h5 className={'text-truncate'}>{storedUserData?.displayName ?? storedUserData?.userName}</h5>
                    <div className="d-flex align-items-center">
                        <div className={`${Classes.userMenuUsername} text-truncate`}>@{storedUserData?.userName}</div>
                        {storedUserData?.emailVerified && (
                            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17"
                                 viewBox="0 0 17 17"
                                 className={`ms-1 ${Classes.userNameClampSvg}`}>
                                <g transform="translate(-0.165 0.137)">
                                    <path
                                        d="M6.639,2.461a2.333,2.333,0,0,1,3.721,0l.017.023a2.333,2.333,0,0,0,1.893.926h.055a2.333,2.333,0,0,1,2.3,2.869l-.046.2a2.333,2.333,0,0,0,.448,1.993l.135.169a2.333,2.333,0,0,1-.818,3.562l-.136.065a2.333,2.333,0,0,0-1.279,1.629l-.024.116a2.333,2.333,0,0,1-3.345,1.6h0a2.333,2.333,0,0,0-2.124,0h0a2.333,2.333,0,0,1-3.345-1.6l-.024-.116a2.333,2.333,0,0,0-1.279-1.629L2.653,12.2a2.333,2.333,0,0,1-.818-3.562l.135-.169a2.333,2.333,0,0,0,.448-1.993l-.046-.2a2.333,2.333,0,0,1,2.3-2.869h.055a2.333,2.333,0,0,0,1.893-.926Z"
                                        transform="translate(0.165 -0.137)" fill="#1EE3A7"/>
                                    <path
                                        d="M5.911,9.479,4.173,7.741a.483.483,0,0,1,.683-.683l1.4,1.394L9.586,5.122a.483.483,0,0,1,.683.683L6.594,9.479a.482.482,0,0,1-.683,0Z"
                                        transform="translate(1.422 1.313)" fill="#fff" stroke="#fff"
                                        strokeWidth="0.6"/>
                                </g>
                            </svg>
                        )}
                    </div>
                </div>
            </div>
            <Dropdown.Item className={'d-flex align-items-center'}
                           onClick={() => navigate(`/artist/${storedUserData?.userName}`)}>
                My Profile
            </Dropdown.Item>
            <Dropdown.Item className={'d-flex align-items-center'} onClick={() => navigate(`/dashboard/uploads`)}>
                My Uploads
            </Dropdown.Item>
            <Dropdown.Item className={'d-flex align-items-center'} onClick={() => navigate(`/dashboard/favourites`)}>
                My Favorite List
            </Dropdown.Item>
            <Dropdown.Item className={'d-flex align-items-center'}
                           onClick={() => navigate(`/dashboard/sensitive-contents`)}>
                Sensitive Contents
            </Dropdown.Item>
            <span className={Classes.divider}/>
            <Dropdown.Item
                onClick={() => navigate(`/dashboard/account-settings`)}
                className={Classes.settingHref}
            >
                Account Settings
            </Dropdown.Item>
            <Dropdown.Item
                as={'button'}
                onClick={logOut}
                className={`${Classes.userMenuUserLogout} mb-2`}
            >
                Logout
            </Dropdown.Item>
        </Dropdown.Menu>
    );
};

export default UserMenu;